import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * `cn(...)` — the standard shadcn class-merger. Keeps tailwind conflict resolution
 * in one place so component variants can compose without stepping on each other.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
